import { abstractOrderedList, abstractUnorderedList, maxAbstractId, numberingDetail, removeNumId } from "./Helper";
import { processMainXML } from "./RichText";
export { runOnChild } from "./OOXML";

export function processRichTextXML(ctx, xml, documentComponent, reports) {
    if (documentComponent === "main.xml") {
        return processMainXML(ctx, xml, reports);
    } else if (documentComponent === "numbering.xml") {
        ctx.maxAbstractId = maxAbstractId(xml) + 1;
        ctx.unOrderedListId = ctx.maxAbstractId.toString();
        ctx.maxAbstractId++;
        ctx.orderedListId = ctx.maxAbstractId.toString();
        removeNumId(ctx.initialMaxNumId , xml);
        
        xml._children.unshift(
            abstractUnorderedList(ctx.unOrderedListId, xml),
            abstractOrderedList(ctx.orderedListId, xml)
        );
        
        ctx.numberingDetails.forEach(({ numId, listType }) => {
            const abstractId = listType === "OL"? ctx.orderedListId: ctx.unOrderedListId;
            const numDetail = numberingDetail(numId.toString(), abstractId, xml);
            xml._children.push(numDetail);
        });
    }
    return xml;
}
